(ns ycweb.app.website.auth.register
  (:require
   [rum.core :as rum]
   [ycweb.app.website.auth.common :as auth.cmn]
   [ycweb.app.website.common.facebook :as fb]
   [ycweb.app.website.website :as website]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.hash :as hash]
   [ycweb.util.urlstate :as urlstate]))

(defmethod comms/receive :web.auth/facebook.registration
  [app-atom {:keys [action errors payload]}]
  (cond
    errors
    (do
      (toaster/close-overlay app-atom :web.login/user-registration)
      (toaster/open-toast app-atom :error "An error occurred" {}))

    (and
      (u/presence action)
      (not= action :redirect))
    (do
      (toaster/close-overlay app-atom :web.login/user-registration)
      (grid/open-modal app-atom action
        {:config
         {:size :small
          :blur-bg? true}}))

    :else
    (grid/dispatch-action app-atom action {:payload payload})))

(defmethod grid/action :web.login/register-by-facebook [app-atom {:keys []}]
  (toaster/open-overlay app-atom :web.login/user-registration)
  (fb/get-login-status
    (fn [status-response]
      (case (:status status-response)
        "connected"
        (comms/ajax-post :web.auth/facebook.registration
          (assoc status-response
            :session/php-session-id (get @app-atom :php-session-id)))

       ;; else
        (fb/login
          (fn [login-response]
            (cond
              (= (:status login-response) "connected")
              (comms/ajax-post :web.auth/facebook.registration
                (assoc login-response
                  :session/php-session-id (get @app-atom :php-session-id)))

              (= (:status login-response) "not_authorized")
              (do
                (toaster/close-overlay app-atom :web.login/user-registration)
                (toaster/open-toast app-atom :error "An error occurred" {}))

              :else
              (toaster/close-overlay app-atom :web.login/user-registration)))
          {:scope "public_profile,email,user_gender,user_birthday"})))))

;; ========== AUTH ACCOUNT CONFIRM SENT ==========
;; Registering with the email of an account that has no password yet (newsletter,
;; guest checkout, saved cart): the password just typed is kept and a confirm link
;; emailed (auth.api.activation); the link's page asks for that password again.
;; Worded as an ordinary verification step: it never says the account existed.
(rum/defc account-confirm-sent-modal-body < rum/reactive [app-atom _ _]
  (let [email (cmn/curact (cmn/process-cursor app-atom) [:register :user/email :value])]
    (list
      [:div.modal__header
       (headings/heading "Verify your email address" {:type :h2 :size :default :flush true :class "modal__heading"})]
      [:div.modal__content
       [:p.yc-paragraph
        [:b
         (str "We've sent a verification link to " (or (u/presence email) "your email address") ".")]]
       [:p.yc-paragraph
        "Open it to finish creating your account."]
       [:p.yc-paragraph
        "If it doesn't arrive shortly, please check your spam folder."]])))

(rum/defc account-confirm-sent-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:single-text "Got it"
      :single-fn #(grid/close-modal app-atom)})])

(defmethod grid/modal-config :web.login/register-confirm-sent [_ _ _]
  {:body-raw account-confirm-sent-modal-body
   :footer account-confirm-sent-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

;; ========== AUTH ACCOUNT EXISTS ==========
(rum/defc account-exists-modal-body < rum/reactive [app-atom _ _]
  (list
    [:div.modal__header
     (headings/heading "Account already exists" {:type :h2 :size :default :flush true :class "modal__heading"})]
    [:div.modal__content
     [:p.yc-paragraph
      [:b
       "We found an account already using that email address in our system."]]
     [:p.yc-paragraph
      "Perhaps you meant to "
      [:a.text-link
       (merge
         (urlstate/href-props app-atom "login")
         {:class (u/bem :text-link [:muted])})
       "log in instead?"]]]))

(rum/defc account-exists-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:left-text "Back"
      :left-no-icon true
      :left-fn
      #(grid/dispatch-action app-atom :web.login/open-email-registration-form {})
      :right-text "Log in"
      :right-no-icon true
      :right-type :web
      :right-options
      (merge
        (urlstate/href-props app-atom "login")
        {:icon :user})})])

(defmethod grid/modal-config :web.login/register-exists [_ _ _]
  {:body-raw account-exists-modal-body
   :footer account-exists-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

;; ========== AUTH ACCOUNT CREATED SUCCESSFULLY ==========
(rum/defc account-created-modal-body < rum/reactive [app-atom _ _]
  (list
    [:div.modal__header
     (headings/heading "Account created 🎉" {:type :h2 :size :default :flush true :class "modal__heading"})]
    [:div.modal__content
     [:p.yc-paragraph
      [:b "You've successfully created a Yuppiechef account."]]
     [:p.yc-paragraph
      "Welcome! You can now add items to your wish list, manage your orders and log returns in "
      [:a.text-link
       (merge
         (urlstate/href-props app-atom "myaccount" ""))
       "your account."]]]))

(rum/defc account-created-modal-footer < rum/reactive [app-atom _ _]
  [:div
   (grid/button-row
     {:left-text "View account"
      :left-type :web
      :left-options (urlstate/href-props app-atom "myaccount" "")
      :right-text "Start shopping"
      :right-type :web
      :right-options (urlstate/href-props app-atom "index")})])

(defmethod grid/modal-config :web.login/register-created [_ _ _]
  {:body-raw account-created-modal-body
   :footer account-created-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

(defmethod comms/receive :web.auth/email.registration [app-atom {:keys [action errors payload]}]
  (cond
    errors
    (do
      (toaster/close-overlay app-atom :web.login/user-registration)
      (toaster/open-toast app-atom :error "An error occurred" {}))

    (and
      (u/presence action)
      (not= action :redirect))
    (do
      (toaster/close-overlay app-atom :web.login/user-registration)
      (grid/open-modal app-atom action
        {:config
         {:size :small
          :blur-bg? true}}))

    :else
    (grid/dispatch-action app-atom action {:payload payload})))

(defn validate-user-input
  [{:user/keys [firstname lastname email password password-confirmation password-length]}]
  (let [errors
        (->>
          {}
          (auth.cmn/validate-email email)
          (auth.cmn/validate-password password password-confirmation password-length))]
    (cond
      (empty? (mapcat second errors))
      {:success true}

      :else
      {:success false :errors errors})))

(defmethod grid/action :web.login/register-by-email [app-atom {:keys [captcha-token]}]
  (let [process-atom (cmn/process-cursor app-atom)
        register-atom (rum/cursor process-atom :register)
        register-data (auth.cmn/yc-input-get-form-values register-atom)
        form-data
        (assoc register-data
          :user/password
          (when
            (:user/password register-data)
            (hash/md5 (:user/password register-data)))
          :user/password-length (count (:user/password register-data))
          :user/password-confirmation
          (when
            (:user/password-confirmation register-data)
            (hash/md5 (:user/password-confirmation register-data))))
        validation (validate-user-input form-data)]
    (cond
      (:success validation)
      (comms/ajax-post :web.auth/email.registration
        (u/maybe assoc
          (assoc form-data
            :captcha-token captcha-token
            :session/php-session-id (get @app-atom :php-session-id))
          ;; Where to go once an existing passwordless account is confirmed
          :after-login-redirect (:afterloginredirect (auth.cmn/redirect-params app-atom))))

      :else
      (do
        (toaster/close-overlay app-atom :web.login/user-registration)
        (auth.cmn/display-input-errors process-atom (:errors validation) :register)))))

;; ========== AUTH REGISTRATION OPTIONS ==========
(rum/defc registration-options-body < rum/reactive [app-atom _ _]
  [:<>
   [:div.modal__header
    (headings/heading "Create an account" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:div.form-field
     (buttons/button-web "Register with email"
       {:type :button
        :on-click
        #(do
           (grid/close-modal app-atom)
           (grid/open-modal app-atom :web.login/register-email
             {:config
              {:size :small
               :blur-bg? true}}))
        :style :primary
        :size :default
        :full true
        :icon :email})]
    #_[:div.form-field
       (buttons/button-web "Register with Google"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom
             :web.login/register-by-service-provider
             {:service-provider :google})
          :style :secondary
          :size :default
          :full true
          :icon :google-g-colour})]
    [:div.form-field
     (buttons/button-web "Register with Facebook"
       {:type :button
        :on-click
        #(grid/dispatch-action app-atom
           :web.login/register-by-facebook
           {:service-provider :facebook})
        :style :facebook
        :size :default
        :full true

        :id "facebook-btn"
        :icon :facebook
        :class :fb-login-button
        :custom-attrs
        {:data-width ""
         :data-size "large"
         :data-button-type "continue_with"
         :data-layout "default"
         :data-auto-logout-link "false"
         :data-use-continue-as "false"
         :data-scope "user_birthday, email"}})]
    #_[:div.form-field
       (buttons/button-web "Register with Apple ID"
         {:type :button
          :on-click
          #(grid/dispatch-action app-atom
             :web.login/register-by-service-provider
             {:service-provider :apple})
          :style :secondary
          :size :default
          :full true
          :icon :apple})]
    [:p.yc-paragraph
     "By creating an account you are agreeing to our "
     [:a.text-link
      (urlstate/href-props app-atom "help" "article" {:id 71 :name "website-terms-and-conditions-of-use"})
      "terms and conditions"]
     ", and "
     [:a.text-link
      (urlstate/href-props app-atom "help" "article" {:id 191 :name "mr-price-group-limited-privacy-policy"})
      "privacy policy"]
     "."]
    [:hr {:class (u/bem :u-hr [:or])}]
    (headings/heading "Already have an account?" {:type :h3 :size :small})
    [:div.form-field
     (buttons/button-web "Log in"
       (merge
         (urlstate/href-props app-atom "login")
         {:type :button
          :style :secondary
          :size :default
          :icon :user
          :full true}))]]
   (toaster/loading-overlay app-atom :web.login/user-registration)])

(defmethod grid/modal-config :web.login/registration-options [_ _ _]
  {:body-raw registration-options-body
   :modal-type :variable
   :cancel-key :auth-modal-close})

;; ========== AUTH ACCOUNT CREATE/REGISTER DETAILS ==========
(rum/defc registration-modal-body < rum/reactive [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        register-atom (rum/cursor process-atom :register)]
    [:<>
     [:div {:id "fb-root"}]
     [:div.modal__header
      (headings/heading "Create an account" {:type :h2 :size :default :flush true :class "modal__heading"})]
     [:div.modal__content
      (forms/split-input-field
        ["First name:" "e.g. Jane"
         (rum/cursor register-atom :user/firstname)
         {:type :user :id :firstname :name :firstname :required? true :yc-input? true}]
        ["Last name:" "e.g. Smith"
         (rum/cursor register-atom :user/lastname)
         {:type :user :id :lastname :name :lastname :required? true :yc-input? true}])
      (forms/input "Email address: (required)" "e.g. jane@domain.com"
        (rum/cursor register-atom :user/email)
        {:type :email
         :icon? true
         :yc-input? true
         :hint "You'll use this email address to log into your account"})
      (forms/password-input "Password: (required)" ""
        (rum/cursor register-atom :user/password)
        {:hint "Must be at least 8 characters and 1 special character or number"
         :yc-input? true})
      (forms/password-input "Confirm password: (required)" ""
        (rum/cursor register-atom :user/password-confirmation)
        {:yc-input? true})
      [:p.yc-paragraph
       "By creating an account you are agreeing to our "
       [:a.text-link
        (urlstate/href-props app-atom "help" "article" {:id 71 :name "website-terms-and-conditions-of-use"})
        "terms and conditions"]
       ", and "
       [:a.text-link
        (urlstate/href-props app-atom "help" "article" {:id 191 :name "mr-price-group-limited-privacy-policy"})
        "privacy policy"]
       "."]
      [:hr {:class (u/bem :u-hr [:or])}]
      (headings/heading "Already have an account?" {:type :h3 :size :small})
      [:p.yc-paragraph
       [:a
        (merge
          (urlstate/href-props app-atom "login")
          {:class
           (u/bem :text-link [:muted])})
        "Log in to your account."]]]
     (toaster/loading-overlay app-atom :web.login/user-registration)]))

(rum/defc registration-modal-footer < rum/reactive [app-atom _ _]
  (let [{:keys [captcha-site-key]} (cmn/curact app-atom :config)]
    (grid/button-row
      {:left-text "Back"
       :left-fn
       #(do
          (grid/close-modal app-atom)
          (grid/open-modal app-atom
            :web.login/registration-options
            {:config
             {:size :small
              :blur-bg? true}}))
       :right-text "Create account"
       :right-fn
       #(do
          (toaster/open-overlay app-atom :web.login/user-registration)
          (appcommon/recaptcha app-atom captcha-site-key :web.login/register-by-email {}))})))

(defmethod grid/modal-config :web.login/register-email [_ _ _]
  {:body-raw registration-modal-body
   :footer registration-modal-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

(defmethod flow/render-screen :web.login/register [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/auth-landing-page app-atom "register")
    {}))

(defmethod t/transition-open :web.login/register [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        facebook-atom (rum/cursor process-atom :facebook)]
    (when (nil? @facebook-atom)
      (comms/ajax-get :web.auth/initiate {}))
    (grid/close-modal app-atom)
    (grid/open-modal app-atom :web.login/registration-options
      {:config
       {:size :small
        :blur-bg? true}})))

(defmethod t/transition-after-open :web.login/register [app-atom _ _]
  (let  [process-atom (cmn/process-cursor app-atom)
         facebook-atom (rum/cursor process-atom :facebook)]
    (fb/load-sdk
      #(fb/init
         {:appId (:login-app-id @facebook-atom)
          :status true
          :cookies true
          :xfbml true
          :version "v16.0"}))))

(defmethod grid/action :web.login/open-email-registration-form [app-atom {:keys []}]
  (grid/close-modal app-atom)
  (grid/open-modal app-atom
    :web.login/register-email
    {:config
     {:size :small
      :blur-bg? true}}))